import store from '@/store';
//sets up routes for the module
//lazy loads
const AdvertOverview = () => import('@/modules/display/views/advert/AdvertOverview');
const ElevatorOverview = () => import('@/modules/display/views/elevator/ElevatorOverview');
const OfferOverview = () => import('@/modules/display/views/offer/OfferOverview');
const PdfOverview = () => import('@/modules/display/views/pdf/PdfOverview');
const EditorForm = () => import('@/modules/display/views/editor/EditorForm');
const AdvertTable = () => import('@/modules/display/views/logs/AdvertTable');
const AliveTable = () => import('@/modules/display/views/logs/AliveTable');
const BootLogTable = () => import('@/modules/display/views/logs/BootLogTable');
const DownloadTable = () => import('@/modules/display/views/logs/DownloadTable');
const ElevatorDayTable = () => import('@/modules/display/views/logs/ElevatorDayTable');
const ElevatorWeekTable = () => import('@/modules/display/views/logs/ElevatorWeekTable');
const ElevatorMonthTable = () => import('@/modules/display/views/logs/ElevatorMonthTable');
const EmailTable = () => import('@/modules/display/views/logs/EmailTable');
const LogFileTable = () => import('@/modules/display/views/logs/LogFileTable');
const OfflineTable = () => import('@/modules/display/views/logs/OfflineTable');
const RideTable = () => import('@/modules/display/views/logs/RideTable');
const ScheduleTable = () => import('@/modules/display/views/logs/ScheduleTable');
const UpdateTable = () => import('@/modules/display/views/logs/UpdateTable');
const ElevatorStatistic  = () => import('@/modules/display/views/elevator/ElevatorStatistic');
const WorkloadStatistic  = () => import('@/modules/display/views/elevator/WorkloadStatistic');
const BudgetStatistic  = () => import('@/modules/display/views/elevator/BudgetStatistic');
const AdvertStatistic  = () => import('@/modules/display/views/advert/AdvertStatistic');
const EmergencyOverview = () => import('@/modules/display/views/emergency/EmergencyOverview');
const CertificateOverview  = () => import('@/modules/display/views/certificate/CertificateOverview');
const DisplayDashboard  = () => import('@/modules/display/views/home/DisplayDashboard');
const HotEmergency = () => import('@/modules/display/views/emergency/HotEmergency');
const RegisterElevator = () => import('@/modules/display/views/elevator/RegisterElevator');

const DISPLAY_URL = '/' + store.state.manager.displayModuleUrl;

const routes = [
  {
    path: DISPLAY_URL,
    name: 'Dashboard',
    component: DisplayDashboard,
    meta: {
      isViewEmployee: true,
      redirectWhenNoAccess: 'Elevator table',
      namespaces: ['display/dashboard', 'dialog', 'snackbar', "components"]
    }
  },
  {
    path: DISPLAY_URL + '/advert',
    name: 'Advert table',
    component: AdvertOverview,
    meta: {
      isAdmin: true,
      isFacilityManager: true,
      isViewEmployee: true,
      namespaces: ['display/advert', 'dialog', 'snackbar', 'components', 'utils', 'enums', 'country']
    }
  },
  {
    path: DISPLAY_URL + '/elevator',
    name: 'Elevator table',
    component: ElevatorOverview,
    meta: {
      isAdmin: true,
      isFacilityManager: true,
      isViewEmployee: true,
      namespaces: ['display/elevator', 'snackbar', 'dialog', 'components', 'utils', 'enums', 'country']
    }
  },
  {
    path: DISPLAY_URL + '/offer',
    name: 'Offer table',
    component: OfferOverview,
    meta: {
      isAdmin: true,
      isCustomerMaster: true,
      namespaces: ['display/offer', 'snackbar', 'dialog', 'components', 'utils', 'common', 'country']
    }
  },
  {
    path: DISPLAY_URL + '/editor',
    name: 'Editor',
    component: EditorForm,
    meta: {
      isAdmin: true,
      isViewEmployee: true,
      isFacilityManager: true,
      namespaces: ['display/editor', 'snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/logs/advert',
    name: 'Advert Logs',
    component: AdvertTable,
    meta: {
      isAdmin: true,
      namespaces: ['display/logs', 'snackbar', 'dialog', 'components', 'utils', 'enums']
    }
  },
  {
    path: DISPLAY_URL + '/logs/alive',
    name: 'Alive Logs',
    component: AliveTable,
    meta: {
      isAdmin: true,
      namespaces: ['display/logs', 'snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/logs/bootlog',
    name: 'BootLog Logs',
    component: BootLogTable,
    meta: {
      isAdmin: true,
      namespaces: ['display/logs', 'snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/logs/download',
    name: 'Download Logs',
    component: DownloadTable,
    meta: {
      isAdmin: true,
      namespaces: ['display/logs', 'snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/logs/elevator-day',
    name: 'Elevator day Logs',
    component: ElevatorDayTable,
    meta: {
      isAdmin: true,
      namespaces: ['display/logs', 'snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/logs/elevator-week',
    name: 'Elevator week Logs',
    component: ElevatorWeekTable,
    meta: {
      isAdmin: true,
      namespaces: ['display/logs', 'snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/logs/elevator-month',
    name: 'Elevator month Logs',
    component: ElevatorMonthTable,
    meta: {
      isAdmin: true,
      namespaces: ['display/logs', 'snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/logs/email',
    name: 'Email Logs',
    component: EmailTable,
    meta: {
      isAdmin: true,
      namespaces: ['display/logs', 'snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/logs/logfile',
    name: 'Logfile Logs',
    component: LogFileTable,
    meta: {
      isAdmin: true,
      namespaces: ['display/logs', 'snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/logs/offline',
    name: 'Offline Logs',
    component: OfflineTable,
    meta: {
      isAdmin: true,
      namespaces: ['display/logs', 'snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/logs/ride',
    name: 'Ride Logs',
    component: RideTable,
    meta: {
      isAdmin: true,
      namespaces: ['display/logs', 'snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/logs/schedule',
    name: 'Schedule Logs',
    component: ScheduleTable,
    meta: {
      isAdmin: true,
      namespaces: ['display/logs', 'snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/logs/update',
    name: 'Update Logs',
    component: UpdateTable,
    meta: {
      isAdmin: true,
      namespaces: ['display/logs', 'snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/statistic/elevator',
    name: 'Elevator statistic table',
    component: ElevatorStatistic,
    meta: {
      isAdmin: true,
      isViewEmployee: true,
      namespaces: ['display/elevator', 'snackbar', 'dialog', 'components', 'utils', "country", "enums"]
    }
  },
  {
    path: DISPLAY_URL + '/statistic/advert',
    name: 'Advert statistic table',
    component: AdvertStatistic,
    meta: {
      isAdmin: true,
      isViewEmployee: true,
      namespaces: ['display/advert', 'snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/statistic/workload',
    name: 'Workload statistic table',
    component: WorkloadStatistic,
    meta: {
      isAdmin: true,
      isViewEmployee: true,
      namespaces: ['display/elevator', 'snackbar', 'dialog', 'components', 'utils', "country", "enums"]
    }
  },
  {
    path: DISPLAY_URL + '/statistic/budget',
    name: 'Budget statistic table',
    component: BudgetStatistic,
    meta: {
      isAdmin: true,
      isViewEmployee: true,
      namespaces: ['display/elevator', 'snackbar', 'dialog', 'components', 'utils', "enums", "country"]
    }
  },
  {
    path: DISPLAY_URL + '/emergency',
    name: 'Emergency overview',
    component: EmergencyOverview,
    meta: {
      isAdmin: true,
      isViewEmployee: true,
      isFacilityManager: true,
      namespaces: ['snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/emergency/:id',
    name: 'Hot Emergency',
    component: HotEmergency,
    meta: {
      isPublic: true,
      namespaces: ['snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/certificate',
    name: 'Certificate overview',
    component: CertificateOverview,
    meta: {
      isAdmin: true,
      namespaces: ['display/certificate', 'snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: DISPLAY_URL + '/pdfs',
    name: 'Pdfs table',
    component: PdfOverview,
    meta: {
      isAdmin: true,
      isCustomerMaster: true,
      namespaces: ['display/pdf', 'snackbar', 'dialog', 'components', 'utils']
    }
  },
  {
    path: '/register/:id',
    name: 'Register the elevator',
    component: RegisterElevator,
    meta: {
      isPublic: true,
      namespaces: ['display/elevator', 'snackbar', 'dialog', 'components', 'country', 'utils']
    }
  }
]

export default routes
